/**
 * Constants instead of typescript enums ---> smaller bundle size
 */
export const AnimateOnClick = 'animate-on-click';
export const RangeDragging = 'range-dragging';
